export default __webpack_public_path__ + "static/media/profile-picture-placeholder.6454dc2e.svg";